import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '@modules/shared.module';
import { CredentialStoresComponent } from '@pages/credential-stores/credential-stores.page';
import { CredentialStoresModalModule } from '@pages/credential-stores/modal/credential-store.modal.module';
import { UiGridResetModule } from '@pages/generics/grid/grid-reset';
import { UiGridModule } from '@uipath/angular/components/ui-grid';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        UiGridModule,
        UiGridResetModule,
        CredentialStoresModalModule,
    ],
    declarations: [
        CredentialStoresComponent,
    ],
    exports: [
        CredentialStoresComponent,
    ],
})
export class CredentialStoresModule { }
